export default __webpack_public_path__ + "static/media/5c48f0be7c02afe7ad40d4fc98d8c846.svg";